<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo" style="width: 850px !important; position: relative !important;">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" v-shortkey="['esc']" @shortkey="cerrar"
                    @click="cerrar"><i class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">

                <div class="contenedor_seleccion_tipo_de_pago">

                    <b-form-select v-if="obj_detalle_descuento.estado == 'PENDIENTE'" v-model="tipo_de_pago" disabled
                        :options="options" size="sm" class="mb-3" />
                    <b-form-select v-else v-model="tipo_de_pago" :options="options" size="sm" class="mb-3" />
                </div>
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Detalle solicitud descuento
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <div class="marco_listado_detalle">

                            <table class="table table-sm table-striped table-bordered" style="font-size: 12px;">
                                <thead>
                                    <tr>
                                        <th style="width: 15%;text-align: center;">
                                            Código
                                        </th>
                                        <th style="width: 30%;">
                                            Nombre
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Precio
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Cantidad
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            SubTotal
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Descuento
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Total C/Descuento
                                        </th>
                                    </tr>

                                </thead>
                                <tbody>

                                    <tr v-for="(item, index) in listado_registros" :key="index">
                                        <td style="text-align: center;">
                                            {{ item.codigo }}
                                        </td>
                                        <td>
                                            {{ item.nombre_articulo }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ item.precio.toLocaleString(undefined, {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ Math.abs(item.cantidad) }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ (item.precio * Math.abs(item.cantidad)).toLocaleString(undefined, {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ item.descuento.toLocaleString(undefined, {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ (item.precio * Math.abs(item.cantidad)) -
                                                item.descuento.toLocaleString(undefined, {
                                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                                }) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-if="obj_detalle_descuento.estado == 'PENDIENTE'" class="col-sm-12 mt-3 mb-3">
                        <button type="button" disabled class="btn btn-sm btn-outline-dark btn-block">Facturar</button>
                    </div>
                    <div v-else class="col-sm-12 mt-3 mb-3">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="generar_factura">Facturar</button>
                    </div>
                </b-row>
            </b-container>
        </div>

        <Cargando v-if="cargando_" :titulo="'Certificando...'" />
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import Cargando from '../Loading/Cargando.vue'
    import pdfMake from 'pdfmake/build/pdfmake.js'
    import pdfFonts from 'pdfmake/build/vfs_fonts.js'
    import { minix } from '../functions/alertas';
    pdfMake.addVirtualFileSystem(pdfFonts);

    export default {
        name: 'ModalDetalleDescuento',
        computed: {
            ...mapState(['obj_detalle_descuento', 'obj_solicitudes_descuento_admon', 'id_empresa_seleccionada', 'datos_usuario', 'nombre_empresa_seleccionada'])
        },
        components: {
            Cargando
        },
        data() {
            return {
                listado_registros: [],
                cargando_: false,
                tipo_de_pago: '',
                options: [
                    { value: '', text: 'Seleccione' },
                    { value: 'EFECTIVO', text: 'Efectivo' },
                    { value: 'TARJETA', text: 'Tarjeta' },
                    { value: 'AMBOS', text: 'Ambos' }
                ]
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async obtener_registros() {
                // se obtienen los registros por el id de la solicitud
                let f = {
                    api: `movimientos-detalles/c/movimientos_por_id?idd=${this.obj_detalle_descuento.id_documento}&empresa=${this.id_empresa_seleccionada}`
                }

                let r = await this.obtener_data(f)
                this.listado_registros = r

            },
            imprimir_ticket(datos_certificacion) {


                // Definir el documento
                const docDefinition = {
                    pageSize: {
                        width: 226.77, // 80mm en puntos (1mm = 2.83465 puntos)
                        height: 'auto'
                    },
                    pageMargins: [5, 5, 5, 5], // Márgenes mínimos para impresora térmica
                    content: [
                        {
                            text: this.nombre_empresa_seleccionada,
                            style: 'header',
                            alignment: 'center'
                        },
                        {
                            text: datos_certificacion.datos_sucursal.nombre_propietario,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: datos_certificacion.datos_sucursal.direccion,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: datos_certificacion.datos_sucursal.establecimiento,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: `NIT: ${datos_certificacion.datos_sucursal.nit}`,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: 'SUJETO A PAGOS TRIMESTRALES ISR.',
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: '----------------------------------------',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_usuario.nombre_sucursal_asignada,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: `NIT: ${datos_certificacion.datos_certificacion.NIT_COMPRADOR}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: `CLI: ${datos_certificacion.datos_certificacion.NOMBRE_COMPRADOR}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'DIR: CIUDAD',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            columns: [
                                { text: 'DESCRIPCION', style: 'tableHeader', width: '58%' },
                                { text: 'CANT.', style: 'tableHeader', width: '20%' },
                                { text: 'MONTO', style: 'tableHeader', width: '22%' }
                            ]
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        // Agrega aquí las filas de productos
                        // {
                        //     columns: [
                        //         { text: 'ALA', style: 'descripcion', width: '50%' },
                        //         { text: '10', style: 'cantidad', width: '20%' },
                        //         { text: 'Q100.00', style: 'monto', width: '30%' }
                        //     ]
                        // },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            columns: [
                                { text: 'Descuento', style: 'total_2', width: '70%' },
                                {
                                    text: `Q${(datos_certificacion.datos_venta.total_descuentos).toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })}`, style: 'cantidad_total_2', width: '30%'
                                }
                            ]
                        },
                        {
                            columns: [
                                { text: 'Total', style: 'total', width: '70%' },
                                {
                                    text: `Q${(datos_certificacion.datos_venta.total_movimiento - datos_certificacion.datos_venta.total_descuentos).toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })}`, style: 'cantidad_total', width: '30%'
                                }
                            ]
                        },
                        {
                            text: 'Documento Tributario Electrónico',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '** Factura **',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: datos_certificacion.datos_certificacion.Serie,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'NÚMERO DE AUTORIZACIÓN:',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: datos_certificacion.datos_certificacion.Autorizacion,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: `CERTIFICACIÓN: ${datos_certificacion.datos_certificacion.Fecha_de_certificacion}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '',
                            style: 'espacio',
                            alignment: 'center'
                        },
                        {
                            text: 'CERTIFICADOR NIT: 77454820',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'DIGIFACT SERVICIOS',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'SOCIEDAD ANONIMA',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '',
                            style: 'espacio',
                            alignment: 'center'
                        },
                        {
                            text: 'Gracias por su compra',
                            bold: true,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '**',
                            style: 'pie_ticket',
                            alignment: 'center'
                        }
                    ],
                    // margin: [left, top, right, bottom]
                    styles: {
                        header: {
                            fontSize: 11,
                            bold: true,
                            margin: [0, 20, 0, 5]
                        },
                        subheader: {
                            fontSize: 10,
                            margin: [0, 0, 0, 3]
                        },
                        normal: {
                            fontSize: 10,
                            margin: [0, 0, 0, 3]
                        },
                        separador: {
                            fontSize: 11,
                            margin: [0, -5, 0, 0]
                        },
                        tableHeader: {
                            fontSize: 10,
                            bold: true,
                            margin: [6, -5, 5, 0]
                        },
                        // total: {
                        //     fontSize: 10,
                        //     bold: true,
                        //     margin: [0, 5, 0, 0]
                        // },
                        descripcion: {
                            fontSize: 9,
                            margin: [6, 0, 0, 0]
                        },
                        cantidad: {
                            fontSize: 9,
                            margin: [30, 0, 0, 0]
                        },
                        monto: {
                            fontSize: 9,
                            margin: [15, 0, 0, 0]
                        },
                        total: {
                            fontSize: 9,
                            bold: true,
                            margin: [130, 0, 0, 20]
                        },
                        total_2: {
                            fontSize: 9,
                            bold: true,
                            margin: [105, 0, 0, 0]
                        },
                        cantidad_total: {
                            fontSize: 9,
                            margin: [15, 0, 0, 20]
                        },
                        cantidad_total_2: {
                            fontSize: 9,
                            margin: [15, 0, 0, 0]
                        },
                        espacio: {
                            fontSize: 10,
                            margin: [0, 0, 0, 10]
                        },
                        pie_ticket: {
                            fontSize: 10,
                            margin: [0, 50, 0, 0]
                        }

                    }
                };

                // Insertando de manera dinamica los productos

                let posicion_a_insertar = 14

                for (let i = 0; i < datos_certificacion.datos_venta.listado.length; i++) {
                    const e = datos_certificacion.datos_venta.listado[i];


                    docDefinition.content.splice(posicion_a_insertar, 0, {
                        columns: [
                            { text: e.nombre, style: 'descripcion', width: '50%' },
                            { text: e.cantidad, style: 'cantidad', width: '20%' },
                            {
                                text: `Q${(e.precio_tarjeta * Math.abs(e.cantidad)).toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                })}`, style: 'monto', width: '30%'
                            }
                        ]
                    })

                    posicion_a_insertar++

                }

                // Crear y descargar el PDF
                pdfMake.createPdf(docDefinition).print();
            },
            async generar_factura() {

                if (this.tipo_de_pago == '') {
                    minix({ icon: 'info', mensaje: 'Seleccione un tipo de pago', tiempo: 3000 })
                    return
                }

                let f = {
                    api: `movimientos-cabeceras/a/convertir-solicitud-a-factura?idd=${this.obj_detalle_descuento.id_documento}`,
                    formulario: {
                        empresa: this.id_empresa_seleccionada,
                        sucursal: this.datos_usuario.sucursal_asignada,
                        tipo_de_pago: this.tipo_de_pago
                    }
                }

                this.cargando_ = true
                let rev = await this.actualizar_data(f)
                this.cargando_ = false

                // IMPRIMIENTO TICKET DE FACTURA
                await this.imprimir_ticket(rev)

                this.cerrar()
            },
            ...mapActions(['actualizar_data', 'obtener_data'])
        },
        mounted() {
            this.obtener_registros()
        },
    }
</script>

<style>
    .marco_listado_detalle {
        width: 100%;
        height: 300px;
        overflow: auto;
    }

    .contenedor_seleccion_tipo_de_pago {
        width: 150px;
        position: absolute;
        top: 60px;
        right: 18px;
        z-index: 999;
    }
</style>